module.exports = __webpack_public_path__ + "img/jk6.cc1c1b2f.png";